module.exports = __webpack_public_path__ + "img/mike.d269df0b.jpeg";